export default Object.freeze({
  StatusChanged: 'status-changed',
  StepChanged: 'step-changed',
  StepStatusChanged: 'step-status-changed',
  EvaluatedApprovers: 'evaluated-approvers',
  // Auto-assign / reassignment. The payload is task metadata, not the new
  // assignee list, so the open detail has to refetch.
  NewTaskAssigned: 'new-task-assigned',
  IRStatusChanged: 'iteration-result-status-changed',
  IRStepChanged: 'iteration-result-step-changed',
  IRStepStatusChanged: 'iteration-result-step-status-changed',
});
